// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2eIR9","footer":"ModalUpdate_footer__OsmMS"};